/**
 * Provides context about the current builder page for GA4 analytics.
 *
 * isPrismBuilder: true when on the Prism Builder page (window.wkData is set)
 *
 * isBuilderGa4EventEnabled: true when:
 *   - On the Prism Builder page — always on
 *   - On the Prints Builder page AND the `printsBuilderEnableGa4Events` feature flag is enabled and
 *      applied to `window.features` (Prints Builder)
 *
 */
const getBuilderAnalyticsContext = () => {
  // Prism Builder: wkData is a server-set global present only on /project_edit/**
  const isPrismBuilder = typeof wkData === 'object';

  // GA4 events enabled always on Prism or Prints Builder FF enabled
  const isBuilderGa4EventEnabled =
    isPrismBuilder || !!window.features?.printsBuilderEnableGa4Events;

  return { isPrismBuilder, isBuilderGa4EventEnabled };
};

export { getBuilderAnalyticsContext };
